<template>
  <div>
    <v-sheet color="#242424" class="custom-sheet">
      {{ getTranslation(
        'Atividades',
        'Actividades')
       }}
    </v-sheet>
    <v-stepper v-model="e1" style="" class="mx-auto custom-stepper">
      <v-stepper-header>
        <template v-for="(n, index) in getFirstPracticeActivity()">
          <v-stepper-step :key="`atividade-${index}`" :step="index + 1" />

          <v-divider v-if="(index + 1) !== getFirstPracticeActivity().length" :key="`divisor-atividade-${index}`" />
        </template>
      </v-stepper-header>

      <v-dialog v-model="dialogActivityVisible" persistent :retain-focus="false" max-width="690">
        <v-card class="d-block">
          <v-img v-if="getFirstPracticeActivityQuestionImage().length" :src="getFirstPracticeActivityQuestionImage()" />

          <v-card-title class="headline">
            {{ getFirstPracticeActivityQuestion() }}
          </v-card-title>
          <v-card-text>
            {{ getFirstPracticeActivityDescription() }}
          </v-card-text>
          <v-divider class="mx-4" dark />
          <v-card-actions>
            <v-row class="ma-0 pa-2 d-block">
              <v-btn v-for="button in getFirstPracticeActivityAnswer()" :key="`button-${button.texto}`"
                class="mb-1 responsive-button" block @click="handleButtonAnswer(button)">
                {{ button.texto }}
              </v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogAnswerVisible" persistent max-width="690">
        <v-card style="white-space: wrap">
          <v-card-title class="headline" :class="titleColour">
            {{ dialogAnswerTitle }}
          </v-card-title>
          <v-card-text>
            {{ dialogAnswerExplanation }}
          </v-card-text>
          <v-divider class="mx-4" dark />
          <v-card-actions class="">
            <v-btn class="mb-1 " block @click="toggleShowDialogAnswer(false)">
              {{ dialogAnswerButton }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-stepper>
    <video id="video" oncontextmenu="return false;" preload="auto" class="video-display" controls
      controlsList="nodownload" src="" />
    <video id="gopro" oncontextmenu="return false;" preload="auto" class="video-display" controls
      controlsList="nodownload" src="" />
    <v-row id="switch-row" class="switch-row-display text-center switch-row-style" no-gutters>
      <v-col v-if="switch1" class="text-center">
        <v-img class="camera-position-icon mx-auto" src="img/baseline_videocam_white_24dp.png" />
      </v-col>
      <v-col v-else class="text-center">
        <v-img class="camera-position-icon mx-auto" src="img/baseline_remove_red_eye_white_24dp.png" />
      </v-col>
      <v-col class="text-center justify-center">
        <v-switch v-model="switch1" class="mr-n2" hide-details />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Const from '@/helpers/const'
let json = require('../../json/pratica-' + Const.PRACTICE_NUMBER + '.json')
export default {
  data() {
    return {
      e1: 1,
      switch1: false,
      dialogActivityVisible: true,
      dialogAnswerVisible: false,
      dialogAnswerExplanation: null,
      dialogAnswerTitle: null,
      dialogAnswerVideo: null,
      dialogAnswerButton: null,
      json: json,
      titleColour: ''
    }
  },

  watch: {
    switch1(val) {
      const switchRowEl = document.getElementById('switch-row')
      if (switchRowEl.style.display === 'none') {
        return
      }

      let show, hide
      if (val) {
        hide = 'gopro'
        show = 'video'
      } else {
        hide = 'video'
        show = 'gopro'
      }
      const hideEl = document.getElementById(hide)
      hideEl.style.display = 'none'
      hideEl.pause()

      const showEl = document.getElementById(show)
      showEl.style.display = 'block'
      showEl.currentTime = hideEl.currentTime
      showEl.play()
    }
  },

  mounted() {
    this.preloadNextVideo()
  },

  methods: {
    handleButtonAnswer(button) {
      const videoSrc = button.video

      this.dialogAnswerExplanation = button.explicacao
      this.dialogAnswerTitle = button.titulo
      this.dialogAnswerVideo = videoSrc
      this.dialogAnswerButton = button.botao
      this.toggleShowDialogAnswer(true)
      if (videoSrc === '') {
        this.titleColour = 'error--text'
      } else {
        this.titleColour = 'success--text'
      }
    },

    async playVideo() {
      this.dialogActivityVisible = false

      const videoEl = document.getElementById('video')
      const goproEl = document.getElementById('gopro')

      goproEl.style.display = 'block'
      try {
        await goproEl.play()

        videoEl.addEventListener('ended', this.onVideoEnded)
        goproEl.addEventListener('ended', this.onVideoEnded)

        this.$bus.$emit('aframe-hide')

        const switchRowEl = document.getElementById('switch-row')
        switchRowEl.style.display = 'block'

        // Do not display switcher button in case videos are equal
        if (videoEl.src === goproEl.src) {
          switchRowEl.style.display = 'none'
        }
      } catch (err) {
        this.onVideoEnded()
      }
    },

    toggleShowDialogAnswer(show) {
      if (show) {
        this.dialogActivityVisible = false
        this.dialogAnswerVisible = true
      } else {
        this.dialogActivityVisible = true
        this.dialogAnswerVisible = false
        if (this.dialogAnswerVideo !== null && this.dialogAnswerVideo !== '') {
          this.playVideo()
        }
      }
    },

    onVideoEnded() {
      const switchRowEl = document.getElementById('switch-row')
      switchRowEl.style.display = 'none'
      this.switch1 = false

      this.$bus.$emit('aframe-show')

      const videoEl = document.getElementById('video')
      videoEl.style.display = 'none'

      const goproEl = document.getElementById('gopro')
      goproEl.style.display = 'none'

      this.e1 = this.e1 + 1
      this.dialogActivityVisible = true

      this.preloadNextVideo()
    },

    preloadNextVideo() {
      let videoSrc, goproSrc

      // we assume that if an answer group have a video then it will also have
      // a gopro video.
      for (let answer of this.getFirstPracticeActivityAnswer()) {
        if (answer.video !== null && answer.video !== '') {
          videoSrc = answer.video
          goproSrc = answer.video_gopro
          break
        }
      }

      if (videoSrc == null || videoSrc === '') {
        this.$emit('selectComponent', 'CoreEtapa5')
        this.$emit('nextStep', '5')

        return
      }

      const videoEl = document.getElementById('video')
      videoEl.src = videoSrc

      const goproEl = document.getElementById('gopro')
      goproEl.src = goproSrc
    },

    getFirstPracticeActivity() {
      const pratica = this.json.pratica[0]
      return pratica.atividade
    },

    getFirstPracticeActivityQuestion() {
      const pratica = this.json.pratica[0]
      return pratica.atividade[this.e1 - 1].pergunta
    },

    getFirstPracticeActivityQuestionImage() {
      const pratica = this.json.pratica[0]
      let imagem = pratica.atividade[this.e1 - 1]['pergunta_imagem']

      if (imagem != null) {
        return 'img/' + imagem
      } else {
        return ''
      }
    },

    getFirstPracticeActivityDescription() {
      const pratica = this.json.pratica[0]
      return pratica.atividade[this.e1 - 1].descricao
    },

    getFirstPracticeActivityAnswer() {
      const pratica = this.json.pratica[0]
      if (pratica.atividade[this.e1 - 1]) {
        return pratica.atividade[this.e1 - 1].resposta
      } else {
        return []
      }
    },
    getTranslation(elementPortuguese, elementSpanish){
      if(Const.PRACTICE_NUMBER.includes('es')){
        return elementSpanish
      }
      return elementPortuguese
    },
  }
}
</script>

<style scoped>
.custom-sheet {
  z-index: 1000;
  position: absolute;
  width: 50vw;
  text-align: center;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  height: 20px;
  border-radius: 0px;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: bold;
  line-height: 20px;
}

video {
  width: 100%;
}

.responsive-button {
  display: block !important;
  white-space: normal !important;
  height: auto !important;
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}

.video-display {
  display: none;
  height: 100vh;
  width: 100vw;
  position: absolute;
  top: 0px;
}

.switch-row-display {
  display: none;
}

.switch-row-style {
  position: absolute;
  bottom: 95px;
  right: 15px;
  font-size: 12px;
  background-color: #272727;
  border-radius: 6px;
  box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
  padding: 10px;
}

.custom-stepper {
  width: 50vw;
  z-index: 10000;
  border-top-right-radius: 0px;
  border-top-left-radius: 0px;
  position: absolute;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  margin-top: 20px;
}

@media only screen and (max-width: 450px) {
  .custom-stepper {
    position: absolute;
    bottom: 0px !important;
    width: 100vw;
    margin-top: 0px;
    margin-bottom: 20px;
  }

  .custom-sheet {
    width: 100vw;
    bottom: 0px;
  }
}

.camera-position-icon {
  width: 22px;
}

.v-input__slot {
  text-align: center !important;
}
</style>
